import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/event-package-addons`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/event-package-addons/${id}`, options)
    .then((response) => {
      let eventPackageAddon = jsona.deserialize(response.data);
      delete eventPackageAddon.links;
      return eventPackageAddon;
    });
}

function add(eventPackageAddon) {
  const payload = jsona.serialize({
    stuff: eventPackageAddon,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/event-package-addons`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(eventPackageAddon) {
  const payload = jsona.serialize({
    stuff: eventPackageAddon,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/event-package-addons/${eventPackageAddon.id}`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/event-package-addons/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
